import MarketIntelligenceController from "pages/Controller/MarketIntelligenceController";
import Select from 'react-select';
import { Grid, Box, useMediaQuery, TextField, InputLabel,Button } from '@mui/material';
import Loader from "components/Loader";

const MarketIntelligence = () => {

    const { loading, subjectlist, divisionlist, userlist, formData,
        handleSelectChange, handleInputChange, handleChange,handleRInputChange, handleSubmit, upload_file, isPhysicalItemCollected, handleOnChange } = MarketIntelligenceController({
            subject: '',
            division: '',
            user: '',
            uploaded_file: '',
            price_cost_meter: '',
            remark:''
        })

    const customStyles = {
        option: (provided) => ({
            ...provided,
            zIndex: 999
        }),
        menu: (provided) => ({
            ...provided,
            zIndex: 1000
        })
    };
    const isMobile = useMediaQuery('(max-width:768px)');
    return (
        <>
            <div className="bg" style={{ display: 'block' }}>
                {loading ? (
                    <div className="overlay">
                        <Loader />
                        <span style={{ marginLeft: '10px' }}>Loading, Please wait...</span>
                    </div>
                ) : null}
                <div className="cutrange">
                    <span className="font20">Market Intelliagence</span>
                </div>
                <form onSubmit={handleSubmit}>
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>

                        <Box
                            className="CustomerProfile"
                            style={{
                                backgroundColor: '#ffffff',
                                borderRadius: '5px',
                                padding: '20px',
                                boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
                                width: isMobile ? '100%' : '40%'
                            }}
                        >
                            <Grid style={{}}  alignItems="center">
                                <Grid style={{marginBottom:'15px'}}  item xs={12} xl={6}>
                                    <Select
                                        name="subject"
                                        value={formData.subject}
                                        onChange={handleSelectChange}
                                        placeholder="Subject"
                                        isSearchable={true}
                                        options={subjectlist}
                                        styles={customStyles}
                                    />
                                </Grid>
                                <Grid style={{marginBottom:'15px'}}  item xs={12} xl={6}>
                                    <Select
                                        name="division"
                                        value={formData.division}
                                        onChange={handleSelectChange}
                                        placeholder="Division"
                                        isSearchable={true}
                                        options={divisionlist}
                                        styles={customStyles}
                                    />
                                </Grid>

                                <Grid style={{marginBottom:'15px'}}  item xs={12} xl={12}>
                                    <TextField
                                        name="uploaded_file"
                                        onChange={handleChange}
                                        type="file"
                                        variant="outlined"
                                        fullWidth
                                        inputRef={upload_file}
                                        InputProps={{
                                            startAdornment: (
                                                <InputLabel shrink htmlFor="uploaded_file">
                                                    Select File
                                                </InputLabel>
                                            )
                                        }}
                                        inputProps={{
                                            multiple: true,
                                        }}
                                    />
                                    <span style={{ color: 'grey' }}>
                                        Note: Max. 3 files
                                    </span>
                                </Grid>

                                <Grid style={{ marginBottom: '15px' }} item xs={12} xl={12}>
                                    <TextField
                                        name="price_cost_meter"
                                        value={formData.price_cost_meter || ""}
                                        onChange={handleRInputChange}
                                        type="text"
                                        variant="outlined"
                                        fullWidth
                                        placeholder="Price/Cost Meter"
                                    />
                                </Grid>

                                <Grid style={{marginBottom:'15px'}}  item xs={12} xl={12}>
                                    <textarea
                                        type="text"
                                        name="remark"
                                        value={formData.remark}
                                        className="form-control inp_text"
                                        id="remark"
                                        rows={4}
                                        cols={20}
                                        onChange={handleRInputChange}
                                        placeholder="Write Remark Here..."
                                        autoFocus
                                    />
                                </Grid>
                                <Grid style={{marginBottom:'15px'}}  item xs={12} xl={6}>
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                        name="isPhysicalItemCollected"
                                        id="isPhysicalItemCollected"
                                        checked={isPhysicalItemCollected}
                                        onChange={handleOnChange}
                                        style={{
                                            height: '15px',
                                            width: '15px',
                                            border: '1px solid black',
                                            backgroundColor: isPhysicalItemCollected ? 'red' : 'white'
                                        }}
                                    />
                                    <label
                                        style={{ marginLeft: '8px', color: 'black', fontSize: '12px' }}
                                        className="form-check-label"
                                        htmlFor="isPhysicalItemCollected"
                                    >
                                        Physical Item Collected
                                    </label>
                                    {isPhysicalItemCollected && (
                                        <Select
                                            name="user"
                                            value={formData.user}
                                            onChange={handleSelectChange}
                                            placeholder="Search User"
                                            isSearchable={true}
                                            options={userlist}
                                            styles={customStyles}
                                            onInputChange={handleInputChange}
                                        />
                                    )}


                                </Grid>

                                <Grid item xs={6} classes={{ root: 'MyGrid' }}>
                                                          <Button variant="contained" color="primary" fullWidth type="submit">
                                                            Submit
                                                          </Button>
                                                        </Grid>


                            </Grid>

                        </Box>


                    </div>
                </form>
            </div>
        </>
    );


}
export default MarketIntelligence;
